var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { TextInput, Text } from "grommet";
export var StyledTextInput = styled(TextInput)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  border-color: #e4e4e8;\n  padding: 11px 8px;\n  height: 32px;\n",
    ]))
);
export var StyledText = styled(Text)(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  line-height: 18px;\n  white-space: nowrap;\n",
    ]))
);
